import type QuillEditor from 'quill';
import { useEffect } from 'react';

const linkTooltipTemplate = `
<span class="title">Visit URL:&nbsp;</span>
<a href="#" class="url" target="_blank" href="about:blank"></a>
<input class="input" type="text">
<span>&nbsp;&#45;&nbsp;</span>
<a href="javascript:;" class="change">Change</a>
<a href="javascript:;" class="remove">Remove</a>
<a href="javascript:;" class="done">Done</a>
`;

type ToolbarButtonLinkProps = {
  editor: QuillEditor;
};

export function ToolbarButtonLink({
  editor,
  ...otherProps
}: ToolbarButtonLinkProps) {
  useEffect(() => {
    editor.addModule('link-tooltip', {
      template: linkTooltipTemplate
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- We only want to run once
  }, []);

  return <span {...otherProps} className="ql-format-button ql-link" />;
}
ToolbarButtonLink.displayName = 'RichTextEditor_ToolbarButtonLink';
